<template>
  <section class="new-quote">
    <quick-quote
      v-if="showQuickQuote"
      :isReferralRequest="true"
      @back="handlerQuickBack"
      @refer="handlerQuickRefer"
      @success="handlerQuickSuccess" />
    <quick-refer
      v-if="showQuickRefer"
      :isReferralRequest="true"
      :referralRequestId="referralRequestId"
      @back="handlerReferBack"
      @success="handlerReferSuccess" />
    <product-quote
      v-if="showQuote"
      :isReferralRequest="true"
      :referralRequestId="referralRequestId"
      @back="handlerQuoteBack"
      @refer="handlerQuoteRefer"
      @success="handlerQuoteSuccess" />

    <policy-info 
      v-if="showPolicyInfo"
      :isReferralRequest="true"
      :referralRequestId="referralRequestId"
      :requestOrderId="requestOrderId"
      :requestQuoId="requestQuoId"
      @back="handlerInfoBack"
      @refer="handlerInfoRefer"
      @success="handlerInfoSuccess" />

    <policy-refer 
      v-if="showPolicyRefer"
      :isReferralRequest="true"
      :requestOrderId="requestOrderId"
      @back="handlerPolicyReferBack"
      @refer="handlerPolicyRefer"
      @success="handlerPolicySuccess" />
    
    <policy-refer-info 
      v-if="showPolicyReferInfo"
      :isReferralRequest="true"
      :referralRequestId="referralRequestId"
      :requestOrderId="requestOrderId"
      @back="handlerPolicyReferInfoRefer"
      @success="handlerPolicyReferInfoSuccess" />

    <policy-payment 
      v-if="showPolicyPayment"
      :isReferralRequest="true"
      :requestOrderId="requestOrderId"
      @back="handlerPaymentBack"
      @success="handlerPaymentSuccess"
      @saveQuote="handlerPaymentSaveQuote"
      @send="handlerPaymentSend" />

    <div
      v-if="showPaymentSuccess"
      class="payment-success">
      <template v-if="paymentState === 0">
        <h2>Payment Success</h2>
        <p>This payment has been successfully processed. A link requesting the signature has been sent to the customer’s SMS/email. </p>
      </template>
      <template v-if="paymentState === 1">
        <h2>Payment Link Sent</h2>
        <p>The payment link has been sent to the customer’s SMS/email address.</p>
      </template>
      <template v-if="paymentState === 2">
        <h2>Quote Saved</h2>
        <p>This quote has been saved to the customer’s account.</p>
      </template>  
      <div class="btn-list">
        <v-button
          type="success"
          @click="onViewTicket">View Ticket</v-button>
        <v-button 
          v-if="paymentState == 0"
          @click="onViewPolicy">View Policy</v-button>
        <v-button 
          v-if="paymentState > 0"
          @click="onViewQuote">View Quote</v-button>
      </div>


    </div>

  </section>
</template>
<script>
import QuickQuote from '@/views/quoting/underwriting'
import QuickRefer from '@/views/quoting/refer'
import ProductQuote from '@/views/quoting/quote'
import policyInfo from '@/views/quoting/client-info'
import PolicyRefer from '@/views/quoting/quote-refer'
import PolicyReferInfo from '@/views/quoting/quote-refer-information'
import PolicyPayment from '@/views/quoting/payment'

export default {
  name: 'NewQuoteRequest',
  components: {
    QuickQuote,
    QuickRefer,
    ProductQuote,
    policyInfo,
    PolicyRefer,
    PolicyReferInfo,
    PolicyPayment
  },
  props: {
    relation: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showQuickQuote: true,
      showQuickRefer: false,
      showQuote: false,
      showPolicyInfo: false,
      showPolicyRefer: false,
      showPolicyReferInfo: false,
      showPolicyPayment: false,
      showPaymentSuccess: false,
      requestOrderId: 0,
      requestQuoId: 0,
      lastStep: 'showQuickQuote', // 部分 step 会去到同一个页面，标记一下，back 做判断
      paymentState: 0,
      paymentData: null
    }
  },
  computed: {
    productId() {
      return this.relation.product_id
    },
    referralRequestId() {
      return this.relation.id
    }
  },
  methods: {
    handlerQuickBack() {
      this.$emit('back')
    },
    handlerQuickRefer() {
      this.showQuickQuote = false
      this.showQuickRefer = true
      
      this.lastStep = 'showQuickQuote'
    },
    handlerQuickSuccess() {
      this.showQuickQuote = false
      this.showQuote = true
    },
    handlerReferBack() {
      this.showQuickRefer = false
      // this.showQuickQuote = true

      this[this.lastStep] = true
    },
    handlerReferSuccess() {
      this.$emit('success')
    },
    handlerQuoteBack() {
      this.showQuote = false
      this.showQuickQuote = true
    },
    handlerQuoteRefer() {
      this.showQuote = false
      this.showQuickRefer = true

      this.lastStep = 'showQuote'
    },
    handlerQuoteSuccess(data) {
      const { order_id, quo_id, product_id } = data
      this.requestOrderId = order_id
      this.requestQuoId = quo_id
      this.showQuote = false
      this.showPolicyInfo = true
    },
    handlerInfoBack() {
      this.showPolicyInfo = false
      this.showQuote = true
    },
    handlerInfoRefer() {
      this.showPolicyInfo = false
      this.showPolicyRefer = true
    },
    handlerInfoSuccess() {
      this.showPolicyInfo = false
      this.showPolicyPayment = true

      this.lastStep = 'showPolicyInfo'
    },
    handlerPolicyReferBack() {
      this.showPolicyRefer = false
      this.showPolicyInfo = true
    },
    handlerPolicyRefer() {
      this.showPolicyRefer = false
      this.showPolicyReferInfo = true
    },
    handlerPolicySuccess() {
      this.showPolicyRefer = false
      this.showPolicyPayment = true

      this.lastStep = 'showPolicyRefer'
    },
    handlerPolicyReferInfoRefer() {
      this.showPolicyReferInfo = false
      this.showPolicyRefer = true
    },
    handlerPolicyReferInfoSuccess() {
      this.$emit('success')
    },
    handlerPaymentBack() {
      this.showPolicyPayment = false
      this[this.lastStep] = true
    },
    handlerPaymentSuccess(data) {
      this.showPaymentSuccess = true
      this.paymentState = 0
      this.paymentData = data 
    },
    handlerPaymentSaveQuote(data) {
      this.showPaymentSuccess = true
      this.paymentState = 1
      this.paymentData = data 
    },
    handlerPaymentSend(data) {
      this.showPaymentSuccess = true
      this.paymentState = 2
      this.paymentData = data 
    },
    onViewTicket() {
      this.$emit('success')
    },
    onViewPolicy() {
      const { order_id, pcy_id } = this.paymentData
      this.$router.push({
        path: this.productId > 50? '/records/policy/manual/detail' :'/records/policy/detail',
        query: {
          id: order_id,
          product_id:this.productId,
          pcy_id
        }
      })
    },
    onViewQuote() {
      const { order_id } = this.paymentData
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: this.orderId,
          product_id: this.productId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.new-quote {
  padding: 20px;
  .payment-success {
    color: #24292e;
    h2 {
      padding-bottom: 30px;
      font-size: 24px;
    }
    p {
      font-size: 14px;
    }
    .btn-list {
      margin-top: 15px;
    }
  }
}
</style>